module.exports = __webpack_public_path__ + "img/noImage.bdf15d64.png";